/** Inclusive local-calendar-day range from `<input type="date">` values (YYYY-MM-DD). */
export function dateInputToEpochRange(fromDate, toDate) {
  const range = {};
  if (fromDate) {
    const [y, m, d] = fromDate.split('-').map(Number);
    if (y && m && d) {
      range.scannedAtFrom = new Date(y, m - 1, d, 0, 0, 0, 0).getTime();
    }
  }
  if (toDate) {
    const [y, m, d] = toDate.split('-').map(Number);
    if (y && m && d) {
      range.scannedAtTo = new Date(y, m - 1, d, 23, 59, 59, 999).getTime();
    }
  }
  return range;
}
